import { API_LOCATION_URL } from 'infrastructure/config';
import { IGetInput, IGetResponse, IBuyerUserClient } from 'interfaceAdapter/gatewaySchemas/IBuyerUserClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class BuyerUserClient implements IBuyerUserClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, userId } = input;
        const PATH = `${API_LOCATION_URL}/buyer/user?user_id=${userId}`;
        const method = 'GET';

        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
